export default "__VITE_ASSET__uid$yg11__"